export const mediaConstant = {
  baseUrl: {
    authenticated: 'https://storage.cloud.google.com/',
    public: 'https://storage.googleapis.com/',
  },
  image: {
    claimFiledOnBehalfOfCustomer: `https://storage.googleapis.com/cdn.orderprotection.com/placeholder/claim-filed-on-behalf-of-the-customer.png`,
    signatureNotFound: `https://storage.googleapis.com/cdn.orderprotection.com/placeholder/signature-not-found.png`,
  },
} as const;

/**
 * Canonical list of MIME types accepted by the platform's media upload pipeline.
 * Used both server-side (upload-media DTO validation) and client-side (file picker
 * `accept` attribute) to keep the two in sync.
 */
export const ACCEPTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/svg+xml',
  'image/heic',
  'image/heif',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/mpeg',
  'video/3gpp',
  'video/avi',
  'video/x-flv',
  'video/wmv',
  'video/mpg',
  'application/pdf',
] as const;

export type ContentType = (typeof ACCEPTED_FILE_TYPES)[number];

export const DEFAULT_ACCEPT = ACCEPTED_FILE_TYPES.join(', ');

/**
 * File-extension → MIME map for inferring `ContentType` when the browser
 * reports an empty or generic type. Values are typed against `ContentType`
 * so any drift from `ACCEPTED_FILE_TYPES` becomes a compile error.
 */
export const EXTENSION_TO_CONTENT_TYPE: Record<string, ContentType> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  heic: 'image/heic',
  heif: 'image/heif',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  webm: 'video/webm',
  mpeg: 'video/mpeg',
  '3gp': 'video/3gpp',
  '3gpp': 'video/3gpp',
  avi: 'video/avi',
  flv: 'video/x-flv',
  wmv: 'video/wmv',
  mpg: 'video/mpg',
  pdf: 'application/pdf',
};
